export default __webpack_public_path__ + "f53c9a2429ac2f0e49b96ff6eae809a3.png";